import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import StatementWrapper from "../common/StatementWrapper/StatementWrapper";
import StatementTable from "../common/StatementTable/StatementTable";
import { GET_ORDER_STATEMENT } from "api/queries/statement";
import Toast from "utils/Alert/Toast/Toast";
import { SELL, ERROR } from "../../../constants";
import { defaultSellFilters } from "../extra";
import { fetchUserData } from "storage/sessionStorage";

const Sell = () => {
	const { portfolio_accounts } = fetchUserData();
	const { id, label } = portfolio_accounts?.[0] || {};
	let options = portfolio_accounts?.map(({ label, id }) => ({
		label,
		value: id,
	}));

	const [portfolio, setPortfolio] = useState({});
	const [sell, setSell] = useState([]);
	const [errorMsg, setErrorMsg] = useState("");

	const [getStatement, { error: err, loading }] = useLazyQuery(
		GET_ORDER_STATEMENT,
		{
			fetchPolicy: "no-cache",
			onCompleted: (data) => setSell(data?.order_statement || []),
			onError: (error) => {
				setSell([]);
				setErrorMsg(error);
			},
		}
	);

	useEffect(() => {
		const { start_date, end_date, type } = defaultSellFilters;
		setPortfolio({ label, id });
		getStatement({
			variables: {
				start_date,
				end_date,
				type,
				portfolio_id: id,
			},
		});
		// eslint-disable-next-line
	}, []);

	return (
		<>
			{err && <Toast msg={errorMsg} variant={ERROR} />}
			<StatementWrapper
				total={sell?.length}
				type={SELL}
				filters={defaultSellFilters}
				refetch={getStatement}
				data={loading ? [] : sell}
				options={options}
				portfolio={portfolio}
				setPortfolio={setPortfolio}
			>
				<StatementTable loading={loading} data={sell} />
			</StatementWrapper>
		</>
	);
};

export default Sell;
